<template>
    <div class="root">
        <div v-for="(cs, i) in cases" class="case-container">
            <div v-if="!cs.readonly" class="btn-icon" @click="deleteCase(i)">
                <a-icon v-if="cases.length > 1" type="delete" theme="filled"/>
            </div>

            <small class="item-label">Silahkan pilih kasus</small><br>

            <a-select
                class="mt-5 mb-10"
                style="width:100%;"
                placeholder="- Pilih Kasus -"
                v-model="cs.case_id"
                :disabled="cs.readonly"
            >
                <a-select-option v-for="kasus in teachingMaterials"
                                 :key="kasus.id" :value="kasus.id">
                    {{ kasus.name }}
                </a-select-option>
            </a-select>

            <small class="item-label">Tambahkan alat dan bahan (Optional)</small><br>

            <a-textarea v-model="cs.note" class="mt-5" rows="5" :disabled="cs.readonly"></a-textarea>
        </div>

        <div class="horizontal-flex mt-5">
            <a-button type="primary" @click="save">
                {{ saveButtonText }}
            </a-button>

            <a-button v-if="showCancelButton" class="ml-10" type="secondary" @click="cancel">
                Batal
            </a-button>

            <div class="flex-fill"></div>

            <a-button type="secondary" @click="addCase">
                Tambah Kasus
            </a-button>
        </div>
    </div>
</template>

<script>
import BookingApi from "../../../repository/api/BookingApi";

export default {
    name: "EditCase",

    props: {
        create: {
            type: Boolean,
            default: false,
        },
        data: {
            type: Object,
            required: true
        },
        teachingMaterials: {
            type: Array,
            required: true,
        },
        saveButtonText: {
            type: String,
            default: 'Simpan',
        },
        showCancelButton: {
            type: Boolean,
            default: true,
        },
        autoSave: {
            type: Boolean,
            default: false,
        },
        canEditFormer: {
            type: Boolean,
            default: true,
        },
    },

    mounted() {
        if (this.create) {
            this.cases = [{
                case_id: null,
                note: ''
            }]
        }
        else {
            this.cases = this.data.case
                .filter(x => x.is_partner == this.data.is_partner)
                .map(x => ({
                    case_id: x.case_id,
                    note: x.note,
                    readonly: !this.canEditFormer
                }))
        }
    },

    data() {
        return {
            cases: []
        }
    },

    methods: {
        addCase() {
            this.cases.push({
                case_id: '',
                note: ''
            })
        },

        deleteCase(index) {
            this.$swal({
                icon: "question",
                text: "Hapus kasus?",
            }).then(r => {
                if (r.isConfirmed) {
                    this.cases.splice(index, 1)
                }
            })


        },

        cancel() {
            this.$emit('cancel')
        },

        save() {
            if (this.cases.length === 0 || this.cases.find(x => !x.case_id)) {
                this.$swal({
                    icon: "warning",
                    text: "Pilih kasus dahulu",
                })

                return
            }

            if (this.autoSave) {
                BookingApi.editCase(this.data.id, this.data.is_partner, this.cases)
                    .then(r => {
                        this.$emit('save')
                    })
                    .catch(e => {
                        this.$swal({
                            icon: e.severity || "error",
                            title: (e.severity || "error").toUpperCase(),
                            text: e.message,
                        });
                    })
            }
            else {
                this.$emit('save', this.cases)
            }
        },
    },

    watch: {
        data() {
            if (this.create)
                return

            this.cases = this.data.case
                .filter(x => x.is_partner == this.data.is_partner)
                .map(x => ({
                    case_id: x.case_id,
                    note: x.note,
                    readonly: !this.canEditFormer
                }))
        }
    }
}
</script>

<style scoped lang="scss">

.root {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    width: 80%;
    margin: auto;
}

.case-container {
    border: 1px solid #DDDDDD;
    background: #FAFAFA;
    padding: 18px;
    position: relative;
    margin: 7px 0;
}

.item-label {
    font-size: 13px;
    color: #1F1F1F;
}

.btn-icon {
    padding: 6px;
    cursor: pointer;
    transition: background-color 0.15s;
    font-size: 18px;
    border-radius: 4px;
    position: absolute;
    top: 2px;
    right: 2px;

    &:hover {
        background: rgba(0, 0, 0, 0.05);
    }
}

</style>